/** Public values only; generated before application boot by the Web container. */
export interface RuntimeConfig {
  smartWorkerUrl?: string;
  apiBase?: string;
  basePath?: string;
}

declare global {
  interface Window {
    __ASSET_RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

export function runtimeConfig(): RuntimeConfig {
  return typeof window === 'undefined' ? {} : window.__ASSET_RUNTIME_CONFIG__ ?? {};
}

export function resolveApiBase(configured: string | undefined, runtime: string | undefined, pageUrl: string): string {
  const value = (runtime ?? configured)?.trim() || '/api/admin/v1';
  const page = new URL(pageUrl);
  const url = new URL(value, page);
  // Fail closed before attaching credentials to a malformed endpoint.
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.search || url.hash
    || (page.protocol === 'https:' && url.protocol !== 'https:')) throw new Error('API 公开地址配置无效');
  return value.replace(/\/+$/, '');
}

export function apiBase(): string {
  return resolveApiBase(undefined, runtimeConfig().apiBase, typeof window === 'undefined' ? 'http://localhost/' : window.location.href);
}
